<icc-list [searchable]="true" [items]="cassonettos"
          [itemTemplate]="'itemImgTitleDescription'"
          [tabs]="tabs"
          (select)="selectCassonetto($event)"
          itemImgHeight="medium"
          ></icc-list>
